import DraggableHeaderCell from './DraggableHeaderCell';

export default DraggableHeaderCell;
